import {
    Theme,
    createStyles,
    makeStyles,
} from '@material-ui/core';
import {
    DateField,
    ReferenceField,
    Show,
    ShowProps,
    TextField,
} from 'react-admin';
import {
    GridShowLayout,
    RaGrid,
} from 'ra-compact-ui';
import { Divider } from '../layout';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerField: {
        },
        contentField: {
            fontSize: '1.1rem',
        },
        footerField: {
            display: 'inline-block',
            marginRight: theme.spacing(2),
        },
    }),
);

export const TeamShow = (props: ShowProps) => {
    const classes = useStyles();
    return (
        <Show {...props}>
            <GridShowLayout>
                <TextField source="id" label="ID" className={classes.headerField} />
                <Divider />
                <RaGrid container spacing={2}>
                    <RaGrid item xs={12}>
                        <TextField source="name" label="名前" fullWidth className={classes.contentField} />
                    </RaGrid>
                </RaGrid>
                <Divider />
                <DateField source="createdAt" label="作成日時" showTime className={classes.footerField} />
                <ReferenceField source="createdBy" label="作成者" reference="users" link="show" className={classes.footerField}>
                    <TextField source="name" />
                </ReferenceField>
                <DateField source="updatedAt" label="更新日時" showTime className={classes.footerField} />
                <ReferenceField source="updatedBy" label="更新者" reference="users" link="show" className={classes.footerField}>
                    <TextField source="name" />
                </ReferenceField>
            </GridShowLayout>
        </Show>
    );
};
